<div class="top-part">
  <div
    class="selection-part"
    [class.disabled]="disabled">
    @for (name of tabNames; track name) {
      <div
        class="selection-item"
        [ngClass]="{ 'tab-selected': selectedTab === name, 'show-border': showBorder }"
        (click)="changeSelection(name)">
        <p>{{ displayText(name) | translate }}</p>
      </div>
    }
  </div>
</div>
